<template>
  <Tutorials class="tutorials-page" />
</template>

<script>
import Tutorials from "@/components/Tutorials.vue";

export default {
  components: {
    Tutorials,
  },
};
</script>
